import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'

// Vue.component('VueMasonry ', VueMasonry);
Vue.use(VueMasonry);
